<template>
  <section class="content_section">
    <SimpleList v-if="this.isLoaded" :serverside="false" @filter="getFiltered"
                :tripsSource="'getAllTrips'"
                :data="trips" :options="options" :title=options.Lang.Archivierte_Vorgänge :cols="cols" :defaultCount="defaultCount" :hideCols="hideCols"
                :emptyState=options.Lang.Keine_Vorgänge_vorhanden buttonAction="Vorgänge"
                :actions="actions" :clean="false" @updateData="getAll()"></SimpleList>
    <FormClient @updateData="getAll()" v-if="options.showClientForm && options.user.loggedIn"
                :currentClient="options.currentClient" :options="options"></FormClient>
    <FormUser @updateData="getAll()" v-if="options.showUserForm && options.user.loggedIn"
              :currentFormUser="options.currentFormUser" :options="options"></FormUser>
    <FormImportTrip @updateData="getAll()" v-if="options.showImportTripFormForm && options.user.loggedIn"
                    :currentTrip="options.currentTrip" :options="options"></FormImportTrip>
    <FormSendEmailToSupplier @updateData="getAll()" v-if="options.showSendEmailToSupplierFormForm && options.user.loggedIn"
                              :currentClient="options.currentTrip" :options="options"></FormSendEmailToSupplier>
  </section>
</template>
<script>

import SimpleList from "@/components/lists/SimpleList";
import FormUser from "@/components/dialogs/FormUser";
import FormClient from "@/components/dialogs/FormClient";
import FormSendEmailToSupplier from "@/components/dialogs/FormSendTripToSupplier";
import FormImportTrip from "@/components/dialogs/FormImportTrip";
import * as moment from 'moment'

const toLower = text => {
  if (text !== null) {
    return text.toString().toLowerCase()
  } else {
    return "";
  }
}

export default {
  name: 'tripsArchived',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  components: {
    SimpleList,
    FormClient,
    FormUser,
    FormImportTrip,
    FormSendEmailToSupplier
  },
  data() {
    return {
      defaultCount: null,
      search: null,
      searchedTrips: [],
      selectedTrips: [],
      trips: [],
      hideCols: ['trip_details', 'trip_details_en', 'firstname', 'lastname', 'sales_firstname', 'sales_lastname', 'date_start', 'date_end', 'done'],
      cols: ['offer_id', 'nezasa_id', 'client_name', 'sales_name', 'agency', 'trip_details', 'trip_details_en', 'firstname', 'lastname', 'sales_firstname', 'sales_lastname', 'date_start', 'date_end', 'trip_date'],
      isLoaded: false,
      actions: [
        {
          icon: 'icon-unarchive_FILL0_wght400_GRAD0_opsz48',
          action: 'unArchivTrip',
          title: this.options.Lang.Aktive_Vorgänge
        },
      ],
    };
  },
  beforeCreate() {
  },
  beforeMount() {
  },
  mounted(){
    if(this.options.currentRoute != 'Brandings'){
      this.options.showBrandForm = false;
    }
    let self = this;
    self.defaultCount = self.options.defaultCount;
  },
  created() {
    this.options.isUploading = true;
    this.getAll();
  },
  methods: {
    getAll() {
      let self = this;
      self.isLoaded = false;
      self.options.isUploading = true;
      //console.log('test');
      this.doPost({userdata: self.options.user,brandings: self.$store.getters.getUser.brandings}, 'getAllTripsArchived', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.trips = values;
            const count = self.trips.length;
            for(let i=0; i<count;i++){
              self.trips[i].trip_date= moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
            }
            //console.log(values.length);
            //console.log(values);
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
    getFiltered(args) {
      //console.log(args);
      let self = this;
      self.options.isUploading = true;
      let where = args && args.where ? args.where : null;
      let order = args && args.order ? args.order : null;
      this.doPost({
        userdata: self.options.user,
        data: {
          where: where,
          sort: order
        },brandings: self.$store.getters.getUser.brandings
      }, 'getAllTripsArchived', function (res) {
        //console.log(res);
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.responseToTableData(res.data.data, self.cols).then(values => {
            self.trips = values;
            const count = self.trips.length;
            for(let i=0; i<count;i++){
              self.trips[i].trip_date= moment(self.trips[i].date_start).format('DD MMM YYYY') + ' - ' + moment(self.trips[i].date_end).format('DD MMM YYYY')
            }
            //console.log('self.trips');
            //console.log(self.trips);
          })
        }
        self.options.isUploading = false;
        self.isLoaded = true;
      });
    },
  }
};
</script>